import { render } from "./LinkField.vue?vue&type=template&id=2666c6be&scoped=true"
import script from "./LinkField.vue?vue&type=script&lang=js"
export * from "./LinkField.vue?vue&type=script&lang=js"

import "./LinkField.vue?vue&type=style&index=0&id=2666c6be&lang=sass&scoped=true"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2666c6be"]])

export default __exports__